module.exports = __webpack_public_path__ + "static/media/cu_step02.f539146e.jpg";